import { createMuiTheme } from "@material-ui/core";


const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Ubuntu',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  overrides: {
    MuiTableRow: {
      root: {
        height: 53
      }
    },
    MuiTableCell: {
      root: {
        padding: "unset"
      }
    }
  }
})

export default theme;